function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M6.39998 5H25.6C26.2365 5 26.847 5.25286 27.297 5.70294C27.7471 6.15303 28 6.76348 28 7.4V25.4C28 26.0365 27.7471 26.647 27.297 27.0971C26.847 27.5471 26.2365 27.8 25.6 27.8H6.39998C5.76347 27.8 5.15302 27.5471 4.70293 27.0971C4.25284 26.647 3.99998 26.0365 3.99998 25.4V7.4C3.99998 6.76348 4.25284 6.15303 4.70293 5.70294C5.15302 5.25286 5.76347 5 6.39998 5ZM6.39998 9.8V13.4H11.2V9.8H6.39998ZM13.6 9.8V13.4H18.4V9.8H13.6ZM25.6 13.4V9.8H20.8V13.4H25.6ZM6.39998 15.8V19.4H11.2V15.8H6.39998ZM6.39998 25.4H11.2V21.8H6.39998V25.4ZM13.6 15.8V19.4H18.4V15.8H13.6ZM13.6 25.4H18.4V21.8H13.6V25.4ZM25.6 25.4V21.8H20.8V25.4H25.6ZM25.6 15.8H20.8V19.4H25.6V15.8Z"
});

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.59df0390.svg";
export { ForwardRef as ReactComponent };